/*
 * @Author: lihefei
 * @Date: 2019-07-25 18:16:57
 * @Last Modified by: lihefei
 * @Last Modified time: 2019-07-26 10:17:05
 */

import Navigation from './navigation.vue';
export default Navigation;
